

export const sendItem = (theme) => {
  // const theme = useSelector((state) => state.theme.toggle);
  return [
    {
      label: (
        <a target="_blank" href="https://opensea.io/collection/dos-punks">
          <span
            style={{ fontSize: "12px", color: theme ? "inherit" : "#f0f0f0" }}
          >
            DOSPUNKS
          </span>
        </a>
      ),
      key: "0",
    },
    {
      label: (
        <a target="_blank" href="https://objkt.com/profile/dos-punks/created">
          <span
            style={{
              fontSize: "12px",
              color: theme ? "inherit" : "#f0f0f0",
              textTransform: "capitalize",
              textTransform: "capitalize",
            }}
          >
            DOSPUNKS (Tez)
          </span>
        </a>
      ),
      key: "1",
    },
    {
      label: (
        <a target="_blank" href="https://opensea.io/collection/dos-trash-birds">
          <span
            style={{
              fontSize: "12px",
              color: theme ? "inherit" : "#f0f0f0",
              textTransform: "capitalize",
            }}
          >
            DOS TRASHBIRDS
          </span>
        </a>
      ),
      key: "10",
    },
    {
        label: (
          <a target="_blank" href="https://opensea.io/collection/dosamigos-official">
            <span
              style={{
                fontSize: "12px",
                color: theme ? "inherit" : "#f0f0f0",
                textTransform: "capitalize",
              }}
            >
              DOSAMIGOS
            </span>
          </a>
        ),
        key: "10123",
      },
  ];
};
